import { collapseElement, expandElement } from '../Utils/Utils';

const LocalContacts = (domEl) => {

	const regionsArea = domEl.querySelector('.regions-area');

	// Regions toggler
	domEl.querySelector('.regions-toggler').addEventListener('click', (e) => {
		e.preventDefault();
		if(domEl.classList.contains('js-expanded')) {
			collapseElement(regionsArea, () => {
				domEl.classList.remove('js-expanded');
			});
		}
		else {
			expandElement(regionsArea);
			domEl.classList.add('js-expanded');
		}
	});

	// Countries toggler
	domEl.querySelectorAll('.region').forEach((region) => {

		const regionInner = region.querySelector('.region-inner');

		region.querySelector('.countries-toggler').addEventListener('click', (e) => {
			e.preventDefault();
			if(region.classList.contains('js-expanded')) {
				collapseElement(regionInner, () => {
					region.classList.remove('js-expanded');
				});
			}
			else {
				expandElement(regionInner);
				region.classList.add('js-expanded');
			}
		});
	});
};

export default LocalContacts;